import { Link } from "react-router-dom";
import { Compass } from "lucide-react";

export default function NotFoundPage() {
  return (
    <div className="py-20 text-center" data-testid="not-found-screen">
      <Compass className="w-10 h-10 text-slate-300 mx-auto" />
      <h2 className="text-xl font-semibold text-slate-800 mt-3">Page not found</h2>
      <p className="text-slate-500 mt-2">The page you are looking for doesn't exist or has moved.</p>
      <Link to="/" data-testid="not-found-go-dashboard-btn" className="inline-flex mt-5 px-4 py-2 rounded-md bg-[#0b192c] hover:bg-[#0f2544] text-white text-sm font-medium transition-colors">
        Go to Dashboard
      </Link>
    </div>
  );
}
